import type { FCMTokenRegistrationPayload, FCMTokenResponse } from '../types/fcm.types';
import { apiClient } from './client';

// API Notification types (using raw API structure)
export interface NotificationMetadata {
  [key: string]: any;
}

export interface Notification {
  notifications_id: string;
  notification_source_id: string | null;
  notification_source: string | null;
  recipient_id: string;
  event_type_id: string;
  notification_text_id: string;
  metadata: NotificationMetadata;
  triggered_by: string | null;
  notification_content: string | null;
  tags: string | null;
  status_text: string;
  status: 'read' | 'unread';
  recipient_platform: string | null;
  timestamp: string;
  notification_text: {
    content: string;
  };
  event_types: {
    event_type: string;
    event_category: string | null;
    event_type_description: string | null;
  };
  message: string;
}

export interface NotificationsResponse {
  success: boolean;
  status: number;
  data: {
    notifications: Notification[];
    pagination: {
      page: number;
      limit: number;
      total: number;
      totalPages: number;
    };
    unreadCount: number;
  };
}

export interface NotificationsParams {
  page?: number;
  limit?: number;
}

// Get all notifications for user (paginated)
export const getNotifications = async (params: NotificationsParams = {}): Promise<NotificationsResponse> => {
  const { page = 1, limit = 20 } = params;
  const response = await apiClient.get(`/notifications?page=${page}&limit=${limit}`);
  return response.data;
};

// Mark a specific notification as read
export const markNotificationAsRead = async (notificationId: string): Promise<Notification> => {
  const response = await apiClient.patch(`/notifications/${notificationId}/read`);
  return response.data;
};

// Mark all notifications as read
export const markAllNotificationsAsRead = async (): Promise<{ message: string }> => {
  const response = await apiClient.post('/notifications/mark-all-read');
  return response.data;
};

// Delete a specific notification
export const deleteNotification = async (notificationId: string): Promise<{ message: string }> => {
  const response = await apiClient.delete(`/notifications/${notificationId}`);
  return response.data;
};

// Register FCM token with backend (requires authentication)
export const registerFCMToken = async (payload: FCMTokenRegistrationPayload): Promise<FCMTokenResponse> => {
  const response = await apiClient.post('/fcm-token/register', payload);
  return response.data;
};

